<div class="payment-success-container w-100">
  <div class="close-modal" (click)="closeModal()"><span>X</span></div>
  <div class="payment-success">
    <div class="icon">
      <img src="assets/images/icons/checkmark_success.svg">
    </div>
    <div class="title mt-3">
      
      {{texts.pagoProgramado}}
    </div>
    <div class="date-payment mt-3">
      {{"Fecha de operacion" | translate}}: {{today}}
    </div>
  </div>
  <div class="separator">

  </div>
  <div class="payment-success-detail mt-2">
    <div class="amount p-2">
      <p class="subtitle">{{texts.importePagado}}</p>
      <p class="value">{{paymentSuccessModel.summaryPayment.amount}}</p>
    </div>
    <div class="commission p-2 layout">
      <p class="subtitle">{{texts.comision}}</p>
      <p class="value">{{paymentSuccessModel.summaryPayment.commission}}</p>
    </div>
    <div class="receiver p-2">
      <p class="subtitle">{{texts.destinatario}}</p>
      <p class="value">{{paymentSuccessModel.summaryPayment.receiver}}</p>
    </div>
    <div class="bank p-2 layout">
      <p class="subtitle">{{texts.banco}}</p>
      <p class="value">{{paymentSuccessModel.summaryPayment.bank}}</p>
    </div>
    <div class="concept p-2 ">
      <p class="subtitle">{{texts.concepto}}</p>
      <p class="value">{{paymentSuccessModel.summaryPayment.concept}}</p>
    </div>
    <div class="reference p-2 layout">
      <p class="subtitle">{{texts.referencia}}</p>
      <p class="value">{{paymentSuccessModel.reference}}</p>
    </div>
  </div>

  <div class="separator"></div>
  
 
  <div 
    class="download-pdf mt-4"
    (click)="downloadPdf()"
  >
    <div class="icon">
      <ng-container *ngIf="!loading; else loadingSpinner">
        <svg  width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.166992 14.6667H11.8337V13H0.166992V14.6667ZM11.8337 5.5H8.50033V0.5H3.50033V5.5H0.166992L6.00033 11.3333L11.8337 5.5Z"
            fill="#0098DD"/>
        </svg>
      </ng-container>
      <ng-template #loadingSpinner>
        <i class="pi pi-spin pi-spinner ms-1" style="font-size: 1rem"></i>
      </ng-template>
    </div>
    <div class="label ms-2">
      {{"Descargar resumen de operacion" | translate}}
    </div>
  </div>
</div>
